var React = require('react');

if (process.env.BROWSER) {
  require('../assets/css/goal.css');
  require('../assets/css/football.css');
}
import { loadWebsite } from '../actions/WebsiteLoadCreator';

class WebsiteEntity extends React.Component {
  static contextTypes = {
    executeAction: React.PropTypes.func
  }
  componentDidMount() {
    const props = this.props;
    this.context.executeAction(loadWebsite, {
      id: props.data.display_name
    });
  }
  render() {
    const website = this.props.data;
    return (
      <div className="container-fluid" style={ { 'padding': '0px' } }>
        <div className="row-fluid clearfix">
          <div className="col-md-3">
          </div>
          <div className="col-md-9">
            <div className="container-fluid container-border">
              <div className="row-fluid">
                <div className="col-md-8">
                  <div className="category-breadcumb" style={ { paddingLeft: '0px' } }>
                    Home/Website/Sports/Football/
                    { website.display_name }
                  </div>
                  <div className="category-title" style={ { paddingLeft: '0px' } }>
                    { website.display_name }
                    <span className="rating" style={ { float: 'none' } }>
      										<input type="radio" id="star5" name="rating" value="5" />
      										<label className="full" for="star5" title="Awesome - 5 stars"></label>
      										<input type="radio" id="star4" name="rating" value="4" />
      										<label className="full" for="star4" title="Pretty good - 4 stars"></label>
      										<input type="radio" id="star3" name="rating" value="3" />
      										<label className="full" for="star3" title="Meh - 3 stars"></label>
      										<input type="radio" id="star2" name="rating" value="2" />
      										<label className="full" for="star2" title="Kinda bad - 2 stars"></label>
      										<input type="radio" id="star1" name="rating" value="1" />
      										<label className="full" for="star1" title="Sucks big time - 1 star"></label>
      										</span>
                    <span className="goal-subtitle">No.1 Football Website</span>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="sort-dropdown">
                    <ul>
                      <li>sort by
                        <i className="icon-angle-down dropdownicon"></i>
                        <ul>
                          <li>hottest this week</li>
                          <li>best rated</li>
                          <li>recommended</li>
                          <li>star</li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="row-fluid">
                <div className="goal">
                  <div className="goal-leftcontainer">
                    <iframe src={ "http://www." + website.name } width="900" height="250" />
                  </div>
                </div>
              </div>
              <div className="row-fluid">
                <div className="col-md-8" style={ { borderRight: '1px solid #ccc' } }>
                  <div className="about">About</div>
                  <div className="about-content">
                    <div>
                      { website.description }
                    </div>
                  </div>
                  <div className="about-link">
                    <i className="icon-link"></i><a href={ "http://www." + website.name }>visit to { website.display_name }</a><span>|</span><i className="icon-share"></i><span>share</span>
                  </div>
                  <div className="item-padding">
                    <div className="category-border"></div>
                  </div>
                  <div className="review-container">
                    <div className="review-title">review
                      <span className="rating" style={ { float: 'none' } }>
      											<input type="radio" id="star5" name="rating" value="5" />
      											<label className="empty" for="star5" title="Awesome - 5 stars"></label>
      											<input type="radio" id="star4" name="rating" value="4" />
      											<label className="empty" for="star4" title="Pretty good - 4 stars"></label>
      											<input type="radio" id="star3" name="rating" value="3" />
      											<label className="empty" for="star3" title="Meh - 3 stars"></label>
      											<input type="radio" id="star2" name="rating" value="2" />
      											<label className="empty" for="star2" title="Kinda bad - 2 stars"></label>
      											<input type="radio" id="star1" name="rating" value="1" />
      											<label className="empty" for="star1" title="Sucks big time - 1 star"></label>
      											</span>
                    </div>
                    <textarea rows="8" cols="80" className="review-writecontent" placeholder="write your reviews ..."></textarea>
                    <div className="review-detail"><span style={ { paddingLeft: '0px' } }>558 folinks</span> | <span>252 review</span> | <span>30 videos</span></div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="tag-title"> TAGS</div>
                  <div className="tag">
                    <div>soccer</div>
                    <div>website</div>
                    <div>fifa</div>
                    <div>ball</div>
                    <div>goal</div>
                    <div>worldcup premier</div>
                  </div>
                  <div className="recommend">
                    <div className="recommend-title">we also recommend</div>
                    <div className="product" style={ { 'height': '15vh' } }>
                      <div className="product-leftcontainer">
                      </div>
                      <div className="product-rightcontainer">
                        <div className="review-rating rating title">
                          2.FIFA.COM
                          <div>
                            <i className="icon-star"></i>
                            <i className="icon-star"></i>
                            <i className="icon-star"></i>
                            <i className="icon-star"></i>
                            <i className="icon-star" style={ { 'color': '#ccc' } }></i>
                          </div>
                        </div>
                        <div className="review-folink">500 folinks | 262 review</div>
                      </div>
                    </div>
                    <div className="product" style={ { 'height': '15vh' } }>
                      <div className="product-leftcontainer">
                      </div>
                      <div className="product-rightcontainer">
                        <div className="review-rating rating title">
                          3.BBCSPORTS.COM
                          <div>
                            <i className="icon-star"></i>
                            <i className="icon-star"></i>
                            <i className="icon-star"></i>
                            <i className="icon-star"></i>
                            <i className="icon-star" style={ { 'color': '#ccc' } }></i>
                          </div>
                        </div>
                        <div className="review-folink">500 folinks | 262 review</div>
                      </div>
                    </div>
                    <div className="product" style={ { 'height': '15vh' } }>
                      <div className="product-leftcontainer">
                      </div>
                      <div className="product-rightcontainer">
                        <div className="review-rating rating title">
                          4.LIVESCORE.COM
                          <div>
                            <i className="icon-star"></i>
                            <i className="icon-star"></i>
                            <i className="icon-star"></i>
                            <i className="icon-star"></i>
                            <i className="icon-star" style={ { 'color': '#ccc' } }></i>
                          </div>
                        </div>
                        <div className="review-folink">500 folinks | 262 review</div>
                      </div>
                    </div>
                    <div className="product" style={ { 'height': '15vh' } }>
                      <div className="product-leftcontainer">
                      </div>
                      <div className="product-rightcontainer">
                        <div className="review-rating title">
                          5.THE GUARDIAN.COM
                          <div>
                            <i className="icon-star"></i>
                            <i className="icon-star"></i>
                            <i className="icon-star"></i>
                            <i className="icon-star"></i>
                            <i className="icon-star" style={ { 'color': '#ccc' } }></i>
                          </div>
                        </div>
                        <div className="review-folink">500 folinks | 262 review</div>
                      </div>
                    </div>
                  </div>
                  <div className="notify-container" style={ { 'margin': '20px' } }>
                    <div className="notification">
                      <div className="notification-title">notification</div>
                      <div className="notification-content">
                        <div className="notifier-name">kuntal chakraborty<span>2Days Ago</span></div>
                        <div>joined folink</div>
                      </div>
                      <div className="notification-content">
                        <div className="notifier-name">sachin velga<span>3Days Ago</span></div>
                        <div>commented on taj hotel</div>
                      </div>
                      <div className="notification-content">
                        <div className="notifier-name">kuntal chakraborty<span>2Days Ago</span></div>
                        <div>joined folink</div>
                      </div>
                      <div className="notification-content">
                        <div className="notifier-name">sachin velga<span>3Days Ago</span></div>
                        <div>commented on taj hotel</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      );
  }
}

module.exports = WebsiteEntity;


// WEBPACK FOOTER //
// ./src/components/WebsiteEntity.js